var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listLength < 1)?_c('section',[_c('h2',{staticClass:"p-12 text-2xl font-light"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }